// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6cfccb5e","453":"75683aa4","455":"37073446","977":"ff075592"}[chunkId] + ".chunk.js";
};